var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTop = function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.449 3.692.092.019c.2-.002.4.06.566.187l.097.084 7.338 7.467a.921.921 0 0 1-.654 1.574.923.923 0 0 1-.56-.19l-.095-.083-5.861-5.98v16.307a.923.923 0 0 1-1.84.108l-.006-.108V6.816l-5.95 5.94a.925.925 0 0 1-1.306-.002.922.922 0 0 1-.082-1.21l.083-.095 7.48-7.468a.91.91 0 0 1 .322-.206.913.913 0 0 1 .376-.083ZM17.844 0a.923.923 0 1 1 0 1.846H.924A.923.923 0 0 1 .923 0h16.92Z",
    fill: "#018DD7",
    fillRule: "nonzero"
  })));
};

export default SvgTop;